import {
    get,
    post
} from '../Requisitions';
var config = require('../../config.json');

export var estabelishment = {
    getInfoStore: function (admin) {
        return get('estabelecimento/' + admin, {
            'Token': config.token
        });
    },
    getStoreBySlug: function (slug) {
        return post('estabelecimento', {
            'Token': config.token
        },{'acao':'buscar','slug':slug});
    }
}